import React from 'react';
import { Card, Col } from 'antd';
import { Chart, Facet } from 'bizcharts';
const DataSet = require('@antv/data-set');
import styles from './style.module.scss';
import QuestionPopover from '../questionPopover';

const DashboardEffectsChart = (props: {
	effect_survey: Array<{
		type: 'AwareDailyBehaviors' | 'BecomeBetterLeaders' | 'RecommendToOthers';
		no_of_yes: number;
		no_of_no: number;
	}>;
}) => {
	const data = props.effect_survey.map(e => {
		const { type, no_of_no, no_of_yes } = e;
		const sum = no_of_no + no_of_yes;
		if (sum < 3) {
			return { type, no_of_no: 0, no_of_yes: 1, ratio: '--' };
		}

		return { type, no_of_no, no_of_yes, ratio: `${Math.round((no_of_yes / sum) * 100)}%` };
	});

	const dv = new DataSet.View().source(data);
	dv.transform({
		type: 'fold',
		fields: ['no_of_no', 'no_of_yes'],
		key: 'number',
		value: 'count'
	}).transform({
		type: 'percent',
		field: 'count',
		dimension: 'number',
		groupBy: ['type'],
		as: ['percent']
	});

	const tips = `These questions are asked during the training journey. If you see no score yet, it means that not enough members have answered the question yet.`;

	return (
		<Col span={12}>
			<Card title="What are the effects?" extra={<QuestionPopover content={tips} />}>
				<Chart height={250} data={dv} forceFit padding={0}>
					<Facet
						type="list"
						fields={['type']}
						showTitle={false}
						padding={0}
						eachView={(view, facet) => {
							view.coord('theta', {
								radius: 0.82,
								innerRadius: 0.72
							});
							view.intervalStack()
								.position('percent')
								.color('number', ['#93B8C8', '#CCE5C8']);
							view.guide().html({
								position: ['50%', '50%'],
								html:
									'<div style="color:#8c8c8c;font-size: 20px;text-align: center;">' +
									facet.data[0].ratio +
									'</div>',
								alignX: 'middle',
								alignY: 'middle'
							});
						}}
					/>
				</Chart>

				<div className={styles.text_box}>
					<div className={styles.text}>
						Say they've become more aware of their daily behaviors
					</div>
					<div className={styles.text}>Say they've become better leaders</div>
					<div className={styles.text}>Say they recommend Yomento to other leaders</div>
				</div>
			</Card>
		</Col>
	);
};

export default DashboardEffectsChart;
